import React from 'react';
export let GtmEvents = /*#__PURE__*/function (GtmEvents) {
  GtmEvents["SELECT_PLAN"] = "Purchase Premium Package Picker";
  GtmEvents["SELECT_CYCLE"] = "Purchase Premium Cycle Selection";
  GtmEvents["CHECKOUT"] = "Purchase Premium Plan View Order Page";
  GtmEvents["SUCCESS"] = "Purchase Premium Plan Success";
  return GtmEvents;
}({});
const reportToDataLayer = function (event, always) {
  var _window$dataLayer;
  if (always === void 0) {
    always = false;
  }
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  const storageKey = `gtm-event:${event}`;
  if (!always) {
    var _localStorage, _localStorage2;
    const alreadyReported = (_localStorage = localStorage) == null ? void 0 : _localStorage.getItem(storageKey);
    if (alreadyReported) {
      return;
    }
    (_localStorage2 = localStorage) == null || _localStorage2.setItem(storageKey, 'true');
  }
  (_window$dataLayer = window.dataLayer) == null || _window$dataLayer.push({
    event
  });
};
export const useGtmLogger = function (event, _temp) {
  let {
    always
  } = _temp === void 0 ? {} : _temp;
  React.useEffect(() => {
    if (event) {
      reportToDataLayer(event, always);
    }
  }, [event, always]);
  const report = React.useCallback(function (reportEvent, reportAlways) {
    if (reportAlways === void 0) {
      reportAlways = false;
    }
    reportToDataLayer(reportEvent, reportAlways);
  }, []);
  return {
    report
  };
};
//# sourceMappingURL=useGtmLogger.js.map